import { HeaderProps } from "./types";
import { cva, type VariantProps } from "class-variance-authority";

const headerStyles = {
  container: cva("flex flex-col", {
    variants: {
      size: {
        desktop: "gap-3",
        dialog: "gap-0",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  stepInfo: cva("font-semibold text-blue-500", {
    variants: {
      size: {
        desktop: "text-md sm:text-sm",
        dialog: "text-xs",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  title: cva("font-bold text-gray-900", {
    variants: {
      size: {
        desktop: "text-3xl",
        dialog: "text-lg",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  description: cva("text-gray-600", {
    variants: {
      size: {
        desktop: "text-lg",
        dialog: "text-sm",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
};

export type HeaderStyleProps = VariantProps<typeof headerStyles.container>;

export const Header = ({
  stepNumber,
  totalSteps,
  title,
  description,
  size = "desktop",
}: HeaderProps) => {
  return (
    <div className={headerStyles.container({ size })}>
      <div className={headerStyles.stepInfo({ size })}>
        Step {stepNumber} of {totalSteps}
      </div>
      <div className={headerStyles.title({ size })}>{title}</div>
      <div className={headerStyles.description({ size })}>{description}</div>
    </div>
  );
};
